import { toQuery } from 'common/hooks/query-service';
import apiFn from 'common/services/api-service';
import { list as getPeopleFn } from 'common/services/people/api';

import { list as listPeopleGroupsFn } from '@domains/People/groups-service';
import { list as listSessionRolesFn } from '@domains/Sessions/roles-service';

const api = (eventId, token) => {
  let header = { Accept: 'application/vnd.eventmobi+json; version=p.5' };
  const withCredentials = !token;

  if (token) {
    header = { ...header, Authorization: `Basic ${token}` };
  }

  return apiFn(`/api/uapi/events/${eventId}/badges`, header, withCredentials);
};

export const list = (eventId, badgeType, include = []) => {
  const params = {};

  if (badgeType) {
    params.badgeType = badgeType;
  }

  if (include.length > 0) {
    params.include = include.join(',');
  }

  return api(eventId)
    .get(null, { params })
    .then(response => response.data.data);
};

export const get = (eventId, id, token) =>
  api(eventId, token)
    .get(id)
    .then(response => response.data.data);

export const create = (eventId, payload) =>
  api(eventId)
    .post(null, payload)
    .then(response => response.data.data);

export const applyTemplate = (eventId, id, templateId) =>
  api(eventId)
    .post(`${id}/apply-template`, { badgeTemplateId: templateId })
    .then(response => response.data.data);

export const update = (eventId, badgeId, payload) =>
  api(eventId)
    .patch(badgeId, payload)
    .then(response => response.data.data);

export const duplicate = (eventId, badgeId, payload) =>
  api(eventId)
    .post(`${badgeId}/duplicate`, payload)
    .then(response => response.data.data);

export const remove = (eventId, id) =>
  api(eventId)
    .delete(id)
    .then(response => response.data.data);

export const getLabels = async (eventId, peopleEntityIds = null) => {
  const queries = [
    listPeopleGroupsFn(eventId).then(({ data }) => data),
    listSessionRolesFn(eventId).then(({ data }) => data),
  ];

  if (peopleEntityIds && peopleEntityIds.length) {
    const query = toQuery({
      filter: {
        id: peopleEntityIds,
      },
      limit: 1000,
      offset: 0,
    });

    queries.push(getPeopleFn(eventId, {}, query, []).then(({ data }) => data));
  }

  const [peopleGroups, sessionRoles, people] = await Promise.all(queries);

  return {
    peopleGroups,
    sessionRoles,
    people,
  };
};

export const searchBadgeValues = (eventId, badgeId, params) =>
  api(eventId)
    .get(`${badgeId}/preview/search`, {
      params: {
        search: params.search,
        fieldName: params.field.fieldName,
        fieldId: params.field.fieldId,
      },
    })
    .then(response => response.data.data);

export const extremeBadgeValues = (eventId, badgeId, { fieldName, fieldId }) =>
  api(eventId)
    .get(`${badgeId}/preview`, { params: { fieldName, fieldId } })
    .then(response => response.data.data);
